// root auth
export const ROUTE_BASE = "/:lang?/";
export const ROUTE_LOGIN = ROUTE_BASE + "login";
export const ROUTE_FORGOTPASSWORD = ROUTE_BASE + "forgotpassword";
export const ROUTE_RESETPASSWORD = ROUTE_BASE + "resetpassword/:token";
export const ROUTE_RESETPASSWORD_MESSAGE = ROUTE_BASE + "resetpassword/success";
